import { useState } from 'react'

import DialogTitle from '@components/mui/DialogTitle'
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, DialogContent } from '@mui/material'

import NavButton from './NavButton'
import Version from './Version'

type Props = {
	onClose: () => void
}

function HelpDialog({ onClose }: Props) {
	return (
		<Dialog fullWidth open closeAfterTransition={false} disableRestoreFocus>
			<DialogTitle onClose={onClose}>Help</DialogTitle>
			<DialogContent data-testid="help-dialog">
				<Version onClose={onClose} data-testid="version" />
			</DialogContent>
		</Dialog>
	)
}

export default function Help() {
	const [open, setOpen] = useState(false)
	return (
		<>
			{open && <HelpDialog onClose={() => setOpen(false)} />}
			<NavButton
				icon={<FontAwesomeIcon style={{ height: '1.5rem' }} size="xl" icon={faCircleQuestion} />}
				primary="Help"
				onClick={() => setOpen(true)}
				data-testid="sidebar-help"
			/>
		</>
	)
}
